import { SORT, SEARCH, INTERVENTION_STATUS, CAMPAIGN_FILES_STATUS, HANDLED, LINKED_INTERVENTION, EMAIL_STATUS } from 'constants/FilterConstants';
import * as types from 'modules/campaignFiles/actionTypes';
import { DEFAULT_SORT } from 'modules/campaignFiles/constants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  text: string,
 *  sort: Array<string> | string,
 *  handled: boolean,
 *  linkedIntervention: boolean,
 *  interventionStatus: string[],
 *  emailStatus: import('modules/campaigns/constants').EmailStatusEnum[],
 *  campaignFileStatus: string[],
 * }} CampaignFileUIDetailsFiltersReducer
 */

/** @type {CampaignFileUIDetailsFiltersReducer} */
export const emptyState = {
  [SEARCH]: null,
  [SORT]: DEFAULT_SORT,
  // Switches
  [HANDLED]: undefined,
  [LINKED_INTERVENTION]: null,
  // Statuses
  [EMAIL_STATUS]: [],
  [INTERVENTION_STATUS]: [],
  [CAMPAIGN_FILES_STATUS]: [],
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<CampaignFileUIDetailsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_CAMPAIGN_FILES_FILTER]: filterAdapter.setFilter,
  [types.SET_CAMPAIGN_FILES_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CAMPAIGN_FILES_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CAMPAIGN_FILES_FILTER]: filterAdapter.removeFilter,
});
